import React, { useState } from "react";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import { CarouselProps } from "./types";
import EffectCarousel from "./effect-carousel.esm";
import { Lightbox } from "../Lightbox";
import { Image } from "@/types/types";

import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/virtual";
import "./effect-carousel.scss";
import "./styles.scss";

const emptyImage = {
  url: "",
  alt: "",
} as Image;

const initialLightboxState = {
  open: false,
  image: emptyImage,
};

export const Carousel = ({ images, expandable = true }: CarouselProps) => {
  const [lightboxState, setLightboxState] = useState(initialLightboxState);
  React.useEffect(() => {
    const swiper = new Swiper(".swiper", {
      // pass EffectCarousel module to modules
      modules: [Navigation, EffectCarousel],
      // specify "carousel" effect
      effect: "carousel",
      grabCursor: true,
      loop: true,
      slidesPerView: "auto",
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      autoplay: {
        delay: 3000,
      },
    });
  }, []);

  const onImageClick = (event) => {
    const {
      target: { src, alt },
    } = event;

    if (expandable) {
      setLightboxState((prev) => ({
        ...prev,
        open: true,
        image: {
          url: src,
          alt,
        },
      }));
    }
  };

  const onCloseLightbox = () => {
    setLightboxState((prev) => ({
      ...prev,
      open: false,
      image: emptyImage,
    }));
  };

  return (
    <React.Fragment>
      <div
        data-testid="Carousel"
        className="swiper">
        <div className="swiper-wrapper">
          {images?.map((image, imageIdx) => (
            <div
              className="swiper-slide"
              key={imageIdx}>
              <div className="swiper-carousel-animate-opacity">
                <img
                  src={image.url as string}
                  alt={`gallery image ${imageIdx + 1}`}
                  onClick={onImageClick}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <Lightbox
        open={lightboxState.open}
        image={lightboxState.image}
        onClose={onCloseLightbox}
      />
    </React.Fragment>
  );
};
